import PropTypes from 'prop-types'
import styled from 'styled-components'
import { transparentize } from 'polished'

import PlacesSelect from 'commons/js/ui/PlacesSelect'

import {
    themeColor,
    themeFontSize,
    themeFontWeight,
} from '@elparking/components'

const StyledPlacesSelect = styled(PlacesSelect)`
    border: 0;
    border-radius: 5px;

    &.Select {
        position: static;
    }

    &.Select > .Select-control {
        position: static;
        border: 0;
        padding-top:0;
        border-bottom: 2px solid transparent;
    }

    &.Select > .Select-control:hover {
        box-shadow: none;
    }

    .Select-input,
    .Select-control {
        background-color: ${themeColor('white')};
    }

    .Select-input {
        padding-left: 0.8em;
    }

    &.Select-placeholder,
    &.Select__single > .Select-control .Select-value {
        padding-left: 0.8em;
    }

    .Select-control,
    &.is-focused > .Select-control {
        font-size: ${themeFontSize('medium')};
        background-color: ${themeColor('white')};
    }

    &.Select.is-focused:not(.is-open) > .Select-control {
        border-bottom: 2px solid ${themeColor('main')};
    }

    &.Select.is-focused > .Select-control {
        border-color: ${themeColor('main')};
    }

    &.Select__single > .Select-control .Select-placeholder {
        font-size: ${themeFontSize('medium')};
        font-style: italic;
    }

    .Select-value-label,
    .Select-input > input,
    &.has-value.Select__single > .Select-control .Select-value .Select-value-label,
    &.has-value.is-pseudo-focused.Select__single > .Select-control .Select-value .Select-value-label {
        font-size: ${themeFontSize('medium')};
        font-weight: ${themeFontWeight('book')};
        color: ${themeColor('gray')};
    }

    .Select-option.is-focused {
        background-color: ${(props) => transparentize(0.6, themeColor('accent')(props))};
        color: ${themeColor('gray')};
    }

    @media screen and (min-width: 48em) {
        .icon-x {
            color: ${themeColor('gray')};
        }

        .Select-control,
        &.is-focused > .Select-control {
            color: ${themeColor('gray')};
            background-color: transparent;
        }

        &.Select__single > .Select-control .Select-placeholder {
            color: ${themeColor('gray60')};
        }

        .Select-placeholder,
        .Select-value-label,
        .Select-input > input,
        &.has-value.Select__single > .Select-control .Select-value .Select-value-label,
        &.has-value.is-pseudo-focused.Select__single > .Select-control .Select-value .Select-value-label {
            color: ${themeColor('gray')};
            font-size: ${themeFontSize('small')};
        }
    }
`

StyledPlacesSelect.propTypes = {
    value: PropTypes.any,
}

export default StyledPlacesSelect
